"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _CloseLink = _interopRequireDefault(require("./CloseLink"));

var _polished = require("polished");

var _Icon = _interopRequireDefault(require("./Icon"));

var _deprecatedPropType = _interopRequireDefault(require("../../utils/deprecated-prop-type"));

var _excluded = ["canClose", "children", "className", "isOpen", "onClose", "type", "theme"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var createNotificationTheme = function createNotificationTheme(_ref, type) {
  var _ref$colors = _ref.colors,
      system = _ref$colors.system,
      neutral = _ref$colors.neutral,
      accent = _ref$colors.accent,
      luna = _ref.luna;
  var config = {
    error: {
      color: {
        backgroundColor: luna ? luna.colors.red(10) : neutral.white,
        borderColorLeft: luna ? luna.colors.red(30) : system.error,
        primary: luna ? luna.colors.red(60) : system.error,
        secondary: luna ? luna.colors.red(10) : neutral.white
      }
    },
    info: {
      color: {
        backgroundColor: luna ? luna.colors.blue(10) : neutral.white,
        borderColorLeft: luna ? luna.colors.blue(30) : accent.blue,
        primary: luna ? luna.colors.blue(60) : accent.blue,
        secondary: luna ? luna.colors.blue(10) : neutral.white
      }
    },
    success: {
      color: {
        backgroundColor: luna ? luna.colors.green(10) : neutral.white,
        borderColorLeft: luna ? luna.colors.green(30) : system.success,
        primary: luna ? luna.colors.green(60) : system.success,
        secondary: luna ? luna.colors.green(10) : neutral.white
      }
    },
    warning: {
      color: {
        backgroundColor: luna ? luna.colors.orange(10) : neutral.white,
        borderColorLeft: luna ? luna.colors.orange(30) : system.warning,
        primary: luna ? luna.colors.orange(60) : system.warning,
        secondary: luna ? luna.colors.orange(10) : neutral.black
      }
    }
  };
  return {
    notification: config[type]
  };
}; // capitilize the first letter of the type, and add a colon


var getIconAltText = function getIconAltText(type) {
  return "".concat(type.charAt(0).toUpperCase() + type.slice(1), ":");
};

var borderSize = (0, _polished.rem)('1px');

var Container = _styledComponents.default.div.withConfig({
  displayName: "InlineNotification__Container",
  componentId: "sc-321uq0-0"
})(["", " border-left:none;display:flex;align-items:flex-start;min-height:", ";padding:", " ", " ", " ", ";position:relative;&:before{bottom:-", ";content:'';left:0;position:absolute;top:-", ";border-left:", " solid;}", " ", ""], function (_ref2) {
  var theme = _ref2.theme;
  return (0, _styledComponents.css)(["background-color:", ";border:", " solid ", ";"], theme.notification.color.backgroundColor, borderSize, theme.luna ? theme.notification.color.secondary : theme.colors.neutral.dime);
}, (0, _polished.rem)('73px'), (0, _polished.rem)('23px'), (0, _polished.rem)('23px'), (0, _polished.rem)('23px'), (0, _polished.rem)('20px'), borderSize, borderSize, function (props) {
  return props.theme.spacing.xsmall;
}, function (_ref3) {
  var media = _ref3.theme.media;
  return media.smallMedium((0, _styledComponents.css)(["padding:", " ", " ", " ", ";min-height:", ";"], (0, _polished.rem)('15px'), (0, _polished.rem)('15px'), (0, _polished.rem)('15px'), (0, _polished.rem)('20px'), (0, _polished.rem)('54px')));
}, function (_ref4) {
  var notification = _ref4.theme.notification;
  return (0, _styledComponents.css)(["::before{border-color:", ";}"], notification.color.borderColorLeft);
});

var Message = _styledComponents.default.div.withConfig({
  displayName: "InlineNotification__Message",
  componentId: "sc-321uq0-1"
})(["flex:1 1 ", ";letter-spacing:0.5px;padding-left:", ";font-size:", ";line-height:1.5;", ""], function (props) {
  return props.theme.spacing.large;
}, function (props) {
  return props.theme.spacing.medium;
}, function (props) {
  return props.theme.spacing.medium;
}, function (_ref5) {
  var media = _ref5.theme.media;
  return media.smallMedium((0, _styledComponents.css)(["font-size:", ";line-height:1.5;padding-left:0;"], (0, _polished.rem)('14px')));
});

var InlineNotification = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(InlineNotification, _React$PureComponent);

  var _super = _createSuper(InlineNotification);

  function InlineNotification() {
    (0, _classCallCheck2.default)(this, InlineNotification);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(InlineNotification, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          canClose = _this$props.canClose,
          children = _this$props.children,
          className = _this$props.className,
          isOpen = _this$props.isOpen,
          onClose = _this$props.onClose,
          type = _this$props.type,
          theme = _this$props.theme,
          props = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var classes = (0, _classnames.default)('ui-inline-notification', className, "ui-inline-notification--".concat(type));

      if (!isOpen) {
        return null;
      }

      var notificationTheme = createNotificationTheme(theme, type);
      return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
        theme: notificationTheme
      }, /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
        className: classes,
        role: "alert"
      }, props), /*#__PURE__*/_react.default.createElement(_Icon.default, {
        role: "img",
        "aria-label": getIconAltText(type),
        type: type,
        className: "ui-inline-notification-icon"
      }), /*#__PURE__*/_react.default.createElement(Message, {
        className: "ui-inline-notification-message"
      }, children), /*#__PURE__*/_react.default.createElement(_CloseLink.default, {
        canClose: canClose,
        onClose: onClose
      })));
    }
  }]);
  return InlineNotification;
}(_react.default.PureComponent);

InlineNotification.propTypes = {
  /** Deprecated: Close button is displayed if onClose is present. */
  canClose: (0, _deprecatedPropType.default)(_propTypes.default.bool, 'Close button is displayed if onClose is present'),

  /** Custom class name to add to InlineNotification. */
  className: _propTypes.default.string,

  /** Message displayed next to the icon. */
  children: _propTypes.default.node.isRequired,

  /** Displays the message if true. */
  isOpen: _propTypes.default.bool,

  /** Function called when close is clicked. */
  onClose: _propTypes.default.func,

  /** Type attribute for the notification. */
  type: _propTypes.default.oneOf(['error', 'info', 'success', 'warning'])
};
InlineNotification.defaultProps = {
  type: 'info'
};

var _default = (0, _styledComponents.withTheme)(InlineNotification);

exports.default = _default;
//# sourceMappingURL=InlineNotification.js.map